import { type ChannelId, ChannelIdZod } from '@onr/schema'
import { schemaDocumentSnapshotQueryOptions, schemaQuerySnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '@/schema'

export const parseChannelIdParams = <T extends { channelId: string }>({ channelId, ...rest }: T) => {
  const parsed = ChannelIdZod.safeParse(channelId)
  return parsed.success ? { ...rest, channelId: parsed.data } : undefined
}

const CLOSED_EVENING_KEY = 'none'

const eveningKey = (eveningId: number | undefined) => (eveningId === undefined ? CLOSED_EVENING_KEY : String(eveningId))

export const channelEveningQuery = (regionId: string, channelId: ChannelId, eveningId: number | undefined) =>
  schemaDocumentSnapshotQueryOptions({
    queryKey: ['regions', regionId, 'channels', channelId, 'evenings', eveningId ?? null],
    factory: collections.regions(regionId).channels(channelId).evenings,
    id: eveningId === undefined ? null : String(eveningId),
  })

export const channelDeletionsQuery = (
  regionId: string,
  channelId: ChannelId,
  eveningId: number | undefined,
  enabled: boolean
) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['regions', regionId, 'channels', channelId, 'evenings', eveningId ?? null, 'deletions'],
    factory: collections.regions(regionId).channels(channelId).evenings(eveningKey(eveningId)).deletions,
    enabled: enabled && eveningId !== undefined,
    query: {
      name: `Channel ${channelId} deletions for region ${regionId} evening ${eveningKey(eveningId)}`,
    },
  })

export const channelMessagesQuery = (regionId: string, channelId: ChannelId, eveningId: number | undefined) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['regions', regionId, 'channels', channelId, 'evenings', eveningId ?? null, 'messages'],
    factory: collections.regions(regionId).channels(channelId).evenings(eveningKey(eveningId)).messages,
    enabled: eveningId !== undefined,
    query: {
      name: `Channel ${channelId} messages for region ${regionId} evening ${eveningKey(eveningId)}`,
      // Newest first, like team messages: the thread column is flex-col-reverse, so this is what
      // puts the oldest message at the top on screen.
      orderBy: [['createdAt', 'desc']],
    },
  })
